import { mapToCanActivate, Routes } from '@angular/router';

import { coreRoutes } from '@next/core-lib/app';
import { AuthComponent } from '@next/core-lib/components';
import { LocationGuard } from '@next/core-lib/relationships';

import { CartConfirmationComponent } from './cart/components/cart-confirmation/cart-confirmation.component';
import { CartOverviewComponent } from './cart/components/cart-overview/cart-overview.component';
import { CartThankYouComponent } from './cart/components/cart-thank-you/cart-thank-you.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { OrdersComponent } from './components/orders/orders.component';
import { PreferencesComponent } from './components/preferences/preferences.component';
import { BulkRepeatOrderPageComponent } from './components/repeat-order/pages/bulk-repeat-order-page.component';
import { GeneralCargoRepeatOrderPageComponent } from './components/repeat-order/pages/general-cargo-repeat-order-page.component';
import { ShopComponent } from './components/shop/shop.component';
import { SilosComponent } from './components/silos/silos.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { maintenanceModeGuard } from './guards/maintenance-mode.guard';
import { repeatOrdersGuard } from './guards/repeat-orders.guard';

const protectedRouteGuards = [...mapToCanActivate([LocationGuard]), repeatOrdersGuard, maintenanceModeGuard];

export const routes: Routes = [
  { path: 'auth', component: AuthComponent },
  {
    path: 'cart',
    component: CartOverviewComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'cart/confirm/:cartId',
    component: CartConfirmationComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'cart/thank-you/:cartId',
    component: CartThankYouComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'shop',
    component: ShopComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'preferences',
    component: PreferencesComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'silos',
    component: SilosComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'repeat-order/bulk',
    component: BulkRepeatOrderPageComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'repeat-order/packaged-goods',
    component: GeneralCargoRepeatOrderPageComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    canActivate: protectedRouteGuards,
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: '/shop',
    pathMatch: 'full',
  },
  ...coreRoutes,
];
